module.exports = __webpack_public_path__ + "images/Dynatrace-bf50f8.png";